function reverseCountdown(reverseCountdownItem, endNumber) {
    const intervalTime = 16; // Update interval in milliseconds
    const totalRuntime = 1000; // Total runtime in milliseconds
    const end = parseInt(endNumber, 10);
    if (!end || isNaN(end)) return;
    const steps = Math.ceil(totalRuntime / intervalTime);
    const stepSize = end / steps;
    let accumulator = 0; // kept as float to avoid rounding-to-zero on small numbers

    const interval = setInterval(() => {
        accumulator += stepSize;
        if (accumulator >= end) {
            reverseCountdownItem.innerHTML = end.toLocaleString();
            clearInterval(interval);
        } else {
            reverseCountdownItem.innerHTML = Math.round(accumulator).toLocaleString();
        }
    }, intervalTime);
}

function startReverseCountdownWhenFullyVisible(reverseCountdownItem) {
    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && entries[0].intersectionRatio === 1) {
            setTimeout(function () {
                reverseCountdown(reverseCountdownItem, reverseCountdownItem.dataset.countdownReverse);
            }, 150);
            observer.unobserve(reverseCountdownItem);
        }
    }, { threshold: 1 });

    observer.observe(reverseCountdownItem);
}

window.addEventListener('load', () => {
    const reverseCountdownItems = document.querySelectorAll("[data-countdown-reverse]");

    for (let reverseCountdownItem of reverseCountdownItems) {
        startReverseCountdownWhenFullyVisible(reverseCountdownItem);
    }
});